import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import NewRiskMatrix from "./NewRiskMatrix";
import { useQuery, useMutation } from "react-apollo";
import { GET_RISK_MATRIX, NEW_RISK_MATRIX } from "../../../../queries/risk.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../partials/loading";
import { ReadData } from "../../../../providers/Patient.Provider";
import RiskDetail from "./RiskDetail";
import RiskMatrixList from "./RiskMatrixList";
import FabButton from "../../../../partials/Buttons/FabButton";

const RiskMatrix = ({ match }) => {
    const { id } = match.params;
    const patient = ReadData();
    const title = "Risk Matrix";
    const [newForm, SetNewForm] = useState(false);
    const [risk, SetRisk] = useState(null);

    // GET
    const { loading, data } = useQuery(GET_RISK_MATRIX, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        variables: { patient: id },
    });

    // CREATE
    const [createFunc, { loading: cLoading }] = useMutation(NEW_RISK_MATRIX, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.NewRisk) {
                const { message, doc } = d.NewRisk;
                SetRisk(doc);
                toast.success(message);
                SetNewForm(false);
                scrollTop();
            }
        },
        update: (caches, { data: { NewRisk } }) => {
            const { GetRisks } = caches.readQuery({
                query: GET_RISK_MATRIX,
                variables: { patient: id },
            });
            GetRisks.docs.unshift(NewRisk.doc);

            caches.writeQuery({
                query: GET_RISK_MATRIX,
                variables: { patient: id },
                data: { GetRisks },
            });
        },
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    {newForm && !risk && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            SetNewForm(false);
                                            SetRisk(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New {title}
                                </header>
                            </div>
                            <div className="card-body" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={cLoading} />
                                <NewRiskMatrix
                                    onSubmit={async (model) => {
                                        scrollTop();
                                        await createFunc({ variables: { model: { ...model, patient: id, admission: patient.lastAdmission } } });
                                    }}
                                    onCancel={() => SetNewForm(false) || SetRisk(null) || scrollTop()}
                                />
                            </div>
                        </div>
                    )}
                    {!newForm && risk && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            SetNewForm(false);
                                            SetRisk(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Patient {title}
                                </header>
                            </div>
                            <div className="card-body" style={{ minHeight: "480px" }}>
                                <RiskDetail item={risk} />
                            </div>
                        </div>
                    )}
                    {!newForm && !risk && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header> {title}</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "480px" }}>
                                <LoadingSpinner loading={loading} />
                                {data && (
                                    <RiskMatrixList
                                        onView={(item) => {
                                            SetNewForm(false);
                                            SetRisk(item);
                                            scrollTop();
                                        }}
                                        items={data.GetRisks.docs}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {!newForm && (
                <FabButton
                    title={` New ${title}`}
                    onClick={() => {
                        SetNewForm(true);
                        SetRisk(null);
                        scrollTop();
                    }}
                />
            )}
        </>
    );
};
export default RiskMatrix;

function scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
